import includes from 'lodash/includes';
import some from 'lodash/some';
import get from 'lodash/get';
//
import deliveryConstants from '../../../constants/deliveryConstants';

function deliveryContainsIncompatibleServices(orderForm) {
  const removedServices = get(orderForm, 'removedServices', []);
  return some(removedServices, service => includes(service?.reason, deliveryConstants.INCOMPATIBLE_SERVICE));
}

export default deliveryContainsIncompatibleServices;
